import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {PatronBalanceTransaction} from '@store/account/account.types';
import {AccountSelectors} from '@store/store.selectors';


@Component({
  selector: 'rn-expanded-transaction-names',
  template: `
    @for (balanceLine of transactionSelectors.sortedBalanceLinesFor(transaction) | select; track balanceLine.id) {
      <div class="expansion-row-content" rnTruncate>
        {{ transactionLineSelectors.nameFor(balanceLine) | select }}
        ({{ transactionLineSelectors.targetFor(balanceLine) | select | format:'TITLE_CASE' }})
      </div>
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ExpandedTransactionNamesComponent {
  @Input() transaction: PatronBalanceTransaction;

  public readonly transactionSelectors = AccountSelectors.BalanceTransactions;
  public readonly transactionLineSelectors = AccountSelectors.BalanceTransactionLines;
}
